import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MenuGuideButton from '../components/MenuGuideButton'
import CounselPracticeCalibration from '../components/counselPractice/CounselPracticeCalibration'
import CounselPracticeContentAudit from '../components/counselPractice/CounselPracticeContentAudit'
import CounselPracticeKnowledgeManager from '../components/counselPractice/CounselPracticeKnowledgeManager'
import CounselPracticeMissionManager from '../components/counselPractice/CounselPracticeMissionManager'
import CounselPracticeOperationsDashboard from '../components/counselPractice/CounselPracticeOperationsDashboard'
import CounselPracticeScenarioManager from '../components/counselPractice/CounselPracticeScenarioManager'
import CounselPracticeUsagePolicy from '../components/counselPractice/CounselPracticeUsagePolicy'

const TABS = [
  { id: 'scenarios', label: '시나리오 관리', path: '/ops/counsel-practice-management' },
  { id: 'missions', label: '미션 관리', path: '/ops/counsel-practice-management/missions' },
  { id: 'operations', label: '운영 현황', path: '/ops/counsel-practice-management/operations' },
  { id: 'calibration', label: '점수 보정', path: '/ops/counsel-practice-management/calibration' },
]

const DEFAULT_TAB = TABS[0].id

export default function OpsCounselPracticeManagementPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const activeTab = useMemo(() => {
    const requested = location.pathname.split('/').filter(Boolean)[2]
    return TABS.some((tab) => tab.id === requested) ? requested : DEFAULT_TAB
  }, [location.pathname])

  const selectTab = (tab) => {
    if (!tab || tab.id === activeTab) return
    navigate(tab.path)
  }

  return (
    <main className="mx-auto max-w-[96rem] px-4 py-6 sm:px-6 lg:px-8" data-testid="ops-counsel-practice-management">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-sm text-slate-500">운영자 · 기타관리</div>
          <h1 className="mt-1 text-2xl font-semibold text-slate-950">상담 시뮬레이션 관리</h1>
        </div>
        <MenuGuideButton menuKey="MENU_OPS_OTHER" />
      </header>

      <div className="mt-5 flex gap-1 overflow-x-auto border-b border-slate-200" role="tablist" aria-label="상담 시뮬레이션 관리 탭">
        {TABS.map((tab) => {
          const active = activeTab === tab.id
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => selectTab(tab)}
              className={`h-10 shrink-0 border-b-2 px-4 text-sm font-semibold ${
                active
                  ? 'border-slate-900 text-slate-950'
                  : 'border-transparent text-slate-500 hover:text-slate-800'
              }`}
            >
              {tab.label}
            </button>
          )
        })}
      </div>

      {activeTab === 'scenarios' ? (
        <div>
          <CounselPracticeScenarioManager />
          <CounselPracticeKnowledgeManager />
        </div>
      ) : null}
      {activeTab === 'missions' ? <CounselPracticeMissionManager /> : null}
      {activeTab === 'operations' ? (
        <div>
          <CounselPracticeOperationsDashboard />
          <div className="mt-8 border-t border-slate-200 pt-6">
            <CounselPracticeUsagePolicy />
          </div>
          <CounselPracticeContentAudit />
        </div>
      ) : null}
      {activeTab === 'calibration' ? <CounselPracticeCalibration /> : null}
    </main>
  )
}
